import { Select } from "./Select";

export const FeatureAndAmenitiesListingComponent = ({
  onChange,
  swimmingPool,
  garden,
  greenAreas,
  terraces,
  lobby,
  surveillance,
  internetAccess,
  gym,
  serviceRoom,
  multipurposeRoom,
}) => {
  return (
    <>
      <h1 className="text-2xl text-center mt-6 mb-6 font-semibold">
        Creando Listing
      </h1>

      <div className="flex gap-3">
        <Select
          title="Alberca"
          id="swimmingPool"
          onChange={onChange}
          value={swimmingPool}
          options={[
            { id: false, value: "No" },
            { id: true, value: "Si" },
          ]}
        />

        <Select
          title="Jardin"
          id="garden"
          onChange={onChange}
          value={garden}
          options={[
            { id: false, value: "No" },
            { id: true, value: "Si" },
          ]}
        />
      </div>
      <div className="flex gap-3">
        <Select
          title="Areas Verdes"
          id="greenAreas"
          onChange={onChange}
          value={greenAreas}
          options={[
            { id: false, value: "No" },
            { id: true, value: "Si" },
          ]}
        />

        <Select
          title="Terrazas"
          id="terraces"
          onChange={onChange}
          value={terraces}
          options={[
            { id: false, value: "No" },
            { id: true, value: "Si" },
          ]}
        />
      </div>
      <div className="flex gap-3">
        <Select
          title="Lobby"
          id="lobby"
          onChange={onChange}
          value={lobby}
          options={[
            { id: false, value: "No" },
            { id: true, value: "Si" },
          ]}
        />

        <Select
          title="Vigilancia"
          id="surveillance"
          onChange={onChange}
          value={surveillance}
          options={[
            { id: false, value: "No" },
            { id: true, value: "Si" },
          ]}
        />
      </div>
      <div className="flex gap-3">
        <Select
          title="Acceso a Internet"
          id="internetAccess"
          onChange={onChange}
          value={internetAccess}
          options={[
            { id: false, value: "No" },
            { id: true, value: "Si" },
          ]}
        />

        <Select
          title="Gym"
          id="gym"
          onChange={onChange}
          value={gym}
          options={[
            { id: false, value: "No" },
            { id: true, value: "Si" },
          ]}
        />
      </div>
      <div className="flex gap-3">
        <Select
          title="Cuarto de Servicio"
          id="serviceRoom"
          onChange={onChange}
          value={serviceRoom}
          options={[
            { id: false, value: "No" },
            { id: true, value: "Si" },
          ]}
        />

        <Select
          title="Salon Usos Multiples"
          id="multipurposeRoom"
          onChange={onChange}
          value={multipurposeRoom}
          options={[
            { id: false, value: "No" },
            { id: true, value: "Si" },
          ]}
        />
      </div>
    </>
  );
};
